import PlayAudioComponent from './play-audio.component'

export default PlayAudioComponent
